import { COLLECTIONS } from "constants/action-types";

export const fetchCollections = (userId, options?) => ({
    payload: { userId, options },
    type: COLLECTIONS.FETCH.START,
});

export const fetchCollectionsSuccess = (payload) => ({
    payload,
    type: COLLECTIONS.FETCH.COMPLETED,
});

export const fetchCollectionsError = (payload, error) => ({
    error,
    payload,
    type: COLLECTIONS.FETCH.COMPLETED,
});

export const clearCollections = () => ({ type: COLLECTIONS.CLEAR });
